import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToolbarService } from '../../../core/services/toolbar.service';
import { AccountConsentsService } from '../account-consents.service';

@Component({
  standalone: false,
  selector: 'app-account-consents',
  templateUrl: './account-consents.component.html',
  styleUrls: ['./account-consents.component.scss'],
})
export class AccountConsentsComponent implements OnInit {
  personalDataConsent = new FormControl<boolean>(false, [Validators.requiredTrue]);
  electronicallySuppliedConsent = new FormControl<boolean>(false, [Validators.requiredTrue]);
  tosConsent = new FormControl<boolean>(false, [Validators.requiredTrue]);
  marketingConsent = new FormControl<boolean>(false);

  consentsForm = new FormGroup({
    personalDataConsent: this.personalDataConsent,
    electronicallySuppliedConsent: this.electronicallySuppliedConsent,
    tosConsent: this.tosConsent,
    marketingConsent: this.marketingConsent,
  });

  tosConsentDetailsVisible = false;
  allSelected = false;
  indeterminateSelection = false;

  constructor(
    private accountConsentsService: AccountConsentsService,
    private route: ActivatedRoute,
    private toolbar: ToolbarService,
  ) {
    this.toolbar.init(this.route);
  }

  ngOnInit(): void {
    this.consentsForm.valueChanges.subscribe(() => {
      this.allSelected = this.updateAllSelected();
      this.indeterminateSelection = this.updateIndeterminateSelection();
    });
  }

  selectAllConsents(checked: boolean): void {
    this.personalDataConsent.setValue(checked);
    this.electronicallySuppliedConsent.setValue(checked);
    this.tosConsent.setValue(checked);
    this.marketingConsent.setValue(checked);
  }

  updateAllSelected(): boolean {
    return this.personalDataConsent.value && this.tosConsent.value && this.consentsForm && this.marketingConsent.value;
  }

  updateIndeterminateSelection(): boolean {
    return (
      !this.allSelected &&
      (this.personalDataConsent.value ||
        this.electronicallySuppliedConsent.value ||
        this.tosConsent.value ||
        this.marketingConsent.value)
    );
  }

  public onAccept(): void {
    this.consentsForm.markAllAsTouched();
    if (!this.consentsForm.invalid) {
      const formValue = {
        marketingConsent: this.marketingConsent.value,
        migrationConsent: true,
      };
      this.accountConsentsService.updateMigrationConsents(formValue);
    }
  }

  public onAcceptFloating(el: HTMLElement): void {
    el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    this.onAccept();
  }
}
